import { useEffect } from 'react';

import { HolidayScene } from './components/HolidayScene';
import { RewardModal } from './components/RewardModal';
import { TweetVerificationModal } from './components/TweetVerificationModal';
import { WrappedVerificationModal } from './components/WrappedVerificationModal';
import { RewardOverlay } from './components/RewardOverlay';
import { PhraseRevealModal } from './components/PhraseRevealModal';
import { RitualCompleteModal } from './components/RitualCompleteModal';
import { StepInstructions } from './components/StepInstructions';
import { GIFTS } from './config/positions';

import { useHolidayStore } from '@/store/useHolidayStore';

export default function HolidayCampaign() {
  const { initializeGifts, reset } = useHolidayStore();

  // Initialize gifts on mount using centralized config
  useEffect(() => {
    initializeGifts(GIFTS.map(g => ({
      id: g.id,
      x: g.x,
      y: g.y,
      width: g.width,
      height: g.height,
    })));

    // Cleanup on unmount
    return () => {
      reset();
    };
  }, [initializeGifts, reset]);

  // Lock scrolling
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <div
      className="fixed inset-0 w-screen h-screen overflow-hidden"
      style={{ touchAction: 'none' }}
    >
      <HolidayScene />
      <StepInstructions />
      <RewardOverlay />
      <WrappedVerificationModal />
      <PhraseRevealModal />
      <TweetVerificationModal />
      <RewardModal />
      <RitualCompleteModal />
    </div>
  );
}
